export const FIND_RESULT_RATINGS_FAILURE = 'FIND_RESULT_RATINGS_FAILURE';

export const findResultRatingsFailure = ({ error, request }) => ({
    type: FIND_RESULT_RATINGS_FAILURE,
    payload: error,
    error: true,
    meta: {
        request
    }
});